import {facebookConfig} from "../../firebase/client-app";
import facebookApi from "./facebook-api";
import _ from "lodash";
import {
    FACEBOOK_AD_IMAGE_FIELDS,
    FACEBOOK_AD_SET_ADS_FIELDS,
    FACEBOOK_SEARCH_TARGETING_TYPES
} from "../constants/facebook-constant";

export {
    createCampaign,
    searchTargeting,
    createAdSet,
    createAdCreative,
    createAd,
    uploadSingleAdImage,
    uploadAdImageList,
    getAdImagesByHashes,
    deleteAdSet,
    deleteAdCreative,
    deleteAd,
    getAdsByAdSet,
    getAdsByAdCampaign,
    activateAd,
    pauseAd,
    activateOrPauseAdSet,
    activateOrPauseAdCampaign,
}

const adsAccountUri = '/act_' + facebookConfig.adAccountId;
const campaignsUri = adsAccountUri + '/campaigns';
const adSetsUri = adsAccountUri + '/adsets';
const adCreativesUri = adsAccountUri + '/adcreatives';
const adsUri = adsAccountUri + '/ads';
const adImagesUri = adsAccountUri + '/adimages';
const searchTargetingUri = '/search';

const createCampaign = async (name, objective) => {
    const data = {
        name: name,
        objective: objective || 'OUTCOME_TRAFFIC',
        status: 'PAUSED',
        special_ad_categories: []
    };

    try {
        const response = await facebookApi.post(campaignsUri, data);
        console.log('Campaign created:', response.data);

        return response.data;
    } catch (error) {
        console.error('Error creating campaign:', error);
    }
}

const searchTargeting = async (searchCriteria) => {
    let url = searchTargetingUri;

    let requestQueryParams = [];
    if (searchCriteria.hasOwnProperty('type') && !_.isEmpty(searchCriteria?.type)) {
        requestQueryParams.push("type=" + searchCriteria?.type);
    }

    if (searchCriteria?.type && searchCriteria?.type === FACEBOOK_SEARCH_TARGETING_TYPES.LOCATION) {
        if (searchCriteria.hasOwnProperty('location_type') && !_.isEmpty(searchCriteria?.location_type)) {
            requestQueryParams.push("location_types=" + [searchCriteria?.location_type]);
        }
    }

    if (searchCriteria.hasOwnProperty('query') && !_.isEmpty(searchCriteria?.query)) {
        requestQueryParams.push("q=" + searchCriteria?.query);
    }

    url += '?' + _.join(requestQueryParams, '&');

    try {
        const response = await facebookApi.get(url);

        return response.data?.data;
    } catch (error) {
        console.error('Error searching targets:', error);
    }
}

const createAdSet = async (adSet) => {
    try {
        const response = await facebookApi.post(adSetsUri, adSet);
        console.log('AdSet created:', response.data);

        return response.data;
    } catch (error) {
        console.error('Error creating AdSet:', error);
    }
}

const createAdCreative = async (adCreative) => {
    adCreative.object_story_spec.page_id = facebookConfig.pageId;
    adCreative.object_story_spec.instagram_actor_id = facebookConfig.instagramActorId;

    try {
        const response = await facebookApi.post(adCreativesUri, adCreative);
        console.log('AdCreative created:', response.data);

        return response.data;
    } catch (error) {
        console.error('Error creating AdCreative:', error);
    }
}

const createAd = async (ad) => {
    try {
        const response = await facebookApi.post(adsUri, ad);
        console.log('Ad created:', response.data);

        return response.data;
    } catch (error) {
        console.error('Error creating Ad:', error);
    }
}

const uploadAdImageList = async (existingBase64DataByCardMap) => {
    try {
        const requestData = new FormData();
        let cardIndex = 0;
        _.forIn(existingBase64DataByCardMap, (imageBase64Data, cardName) => {
            ++cardIndex
            requestData.append('filename' + cardIndex, dataURItoBlob(imageBase64Data), cardName + '.png');
        });

        const response = await facebookApi.post(adImagesUri, requestData);
        console.log('AdImage uploaded:', response.data);

        return response.data;
    } catch (error) {
        console.error('Error uploadAdImages:', error);
    }
}

const uploadSingleAdImage = async (imageBase64Data, cardKey) => {
    try {
        const requestData = new FormData();
        requestData.append('filename', dataURItoBlob(imageBase64Data), cardKey + '.png');

        const response = await facebookApi.post(adImagesUri, requestData);
        console.log('AdImage uploaded:', response.data);

        return response.data;
    } catch (error) {
        console.error('Error uploadAdImages:', error);
    }
}

const dataURItoBlob = (dataURI) => {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], {type: mimeString});
}

const getAdImagesByHashes = async (imageHashes) => {
    try {
        let url = adImagesUri + '?hashes=' + '["' + _.join(imageHashes, '","') + '"]';
        url += "&fields=" + FACEBOOK_AD_IMAGE_FIELDS;

        const response = await facebookApi.get(url);

        return response.data;
    } catch (error) {
        console.error('Error getting AdImages:', error);
    }
}

const deleteAdSet = async (adSet) => {
    try {
        let url = '/' + adSet.adSetId;
        const response = await facebookApi.delete(url);
        console.log('Ad Set Deleted:', response.data);

        return response.data;
    } catch (error) {
        console.error('Error Deleting Ad Set:', error);
    }
}

const deleteAdCreative = async (adCreative) => {
    try {
        let url = '/' + adCreative.adCreativeId;
        const response = await facebookApi.delete(url);
        console.log('Ad Creative Deleted:', response.data);

        return response.data;
    } catch (error) {
        console.error('Error Deleting Ad Creative:', error);
    }
}

const deleteAd = async (ad) => {
    try {
        let url = '/' + ad.adId;
        const response = await facebookApi.delete(url);
        console.log('Ad Deleted:', response.data);

        return response.data;
    } catch (error) {
        console.error('Error Deleting Ad:', error);
    }
}

const getAdsByAdSet = async (adSet) => {
    try {
        let url = '/' + adSet.adSetId + '/ads';
        url += "?fields=" + FACEBOOK_AD_SET_ADS_FIELDS;
        const response = await facebookApi.get(url);
        return response.data?.data;
    } catch (error) {
        console.error('Error Getting Ads by Ad Set:', error);
    }
}

const getAdsByAdCampaign = async (adCampaign) => {
    try {
        let url = '/' + adCampaign.campaignId + '/ads';
        url += "?fields=" + FACEBOOK_AD_SET_ADS_FIELDS;
        const response = await facebookApi.get(url);
        return response.data?.data;
    } catch (error) {
        console.error('Error Getting Ads by Ad Campaign:', error);
    }
}

const activateAd = async (ad) => {
    try {
        let url = '/' + ad.adId;
        facebookApi.defaults.headers.common['status'] = 'ACTIVE';

        const response = await facebookApi.post(url, ad);
        console.log('Ad Activated:', response.data);

        return response.data;
    } catch (error) {
        console.error('Error Activating Ad:', error);
    }
}

const pauseAd = async (ad) => {
    try {
        let url = '/' + ad.adId;
        facebookApi.defaults.headers.common['status'] = 'PAUSED';

        const response = await facebookApi.post(url, ad);
        console.log('Ad Paused:', response.data);

        return response.data;
    } catch (error) {
        console.error('Error Pausing Ad:', error);
    }
}

const activateOrPauseAdSet = async (adSet) => {
    try {
        let url = '/' + adSet.adSetId;
        const updateAdSet = {
            status: adSet.status
        };

        const response = await facebookApi.post(url, updateAdSet);

        return response.data;
    } catch (error) {
        console.error('Error Updating AdSet:', error);
    }
}

const activateOrPauseAdCampaign = async (campaign) => {
    try {
        let url = '/' + campaign.campaignId;
        const updateAdCampaign = {
            status: campaign.status
        };

        const response = await facebookApi.post(url, updateAdCampaign);

        return response.data;
    } catch (error) {
        console.error('Error Updating AdCampaign:', error);
    }
}
